declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DISABLE_GTM?: boolean;
  }
}

export function isDisableCsrGtm(): boolean {
  return globalThis?.window?.DISABLE_GTM === true;
}
